import { axios } from "../../config/axiosConfig";
import { endpoints } from "../../config/apiConfig";

async function getAllFaqs (
    payload,
) {
    return axios
    .post(endpoints.faq.getAllFaQ, payload)
    .then(response => {
      let data = response?.data;
      return data;
    })
    .catch(error => {
      return null;
    });
}

async function getFaqCategories () {
    return axios
    .get(endpoints.faq.getFaqCategory)
    .then(response => {
        return response?.data;
    })
    .catch(error => {
        return null;
    });
};

async function addUpdateFaq (payload) {
    return axios
    .post(endpoints.faq.addUpdateFaQ, payload)
    .then(response => {
        return response?.data;
    })
    .catch(error => {
        return null;
    });
};

async function getFaqById (id) {
    return axios
    .get(`${endpoints.faq.getFaQById}/${id}`)
    .then(response => {
        return response?.data;
    })
    .catch(error => {
        return null;
    });
};

async function deleteFaq(ids) {
    console.log("Id**", ids)
    return axios
        .delete(endpoints.faq.deleteFaQs, {data: ids})
        .then(response => {
            return response?.data;
        })
        .catch(error => {
            console.log("error", error);
            return null;
        });
}


export const faqsApi = {
    getAllFaqs: getAllFaqs,
    getFaqCategories: getFaqCategories,
    addUpdateFaq: addUpdateFaq,
    getFaqById: getFaqById,
    deleteFaq: deleteFaq,
};